module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBold.b70002a0.eot";